<template>
  <el-drawer direction="btt" v-model="is_show_drawer" size="360" class="add-product-to-collections-drawer"
    :destroy-on-close="true">
    <header class="head">
      <h2>Add to Collection</h2>
      <i @click="is_show_drawer = false"><svg-icon name="close" /></i>
    </header>
    <div class="list-wrap" v-loading="is_loading || is_updating">
      <div class="empty" v-if="!is_loading && collections.length === 0">
        <i><svg-icon name="collection" /></i>
        <el-button type="primary" @click="emit('add')"><svg-icon name="plus" />Create First Collection</el-button>
      </div>
      <ul v-else-if="!is_loading" class="collection-list">
        <li v-for="collection in collections" :class="[collection.is_disabled && 'dis-li']" :key="collection.id" @click="select(collection)">
          <collection-images v-if="collection.cover_image_url" :image="collection.cover_image_url"
            :images="collection.first_4_product_thumbnails" />
          <img v-else :src="TempImg" class="collection-grid" />
          <div class="info">
            <h3>{{ collection.title?collection.title:'---' }}</h3>
            <p>{{ collection.product_count }} products</p>
            <span v-if="collection.status === 100">
              Active
            </span>
          </div>
          <i><svg-icon :name="collection.is_selected ? 'checked-circle' : 'checkbox-circle'" /></i>
        </li>
      </ul>
      <div class="more-btn" v-if="!is_end && !is_loading && collections.length !== 0" @click="getCollections(true)"
        v-loading="is_loading_more">
        <el-button plain v-loading="is_loading_more">Load more</el-button>
      </div>
      <div class="more-btn" v-if="is_end && !is_loading && collections.length !== 0">
        <span>End of list</span>
      </div>
    </div>
    <footer class="foot" v-if="!is_loading && collections.length !== 0">
      <el-button plain @click="event.emit('open-collection-edit-dialog', { id: 1, row: null, which: 'collection' })"
        size="large"><svg-icon name="plus" />Create</el-button>
      <el-button type="primary" @click="save" :disabled="is_can_save" size="large">Done</el-button>
    </footer>
  </el-drawer>
</template>

<script setup>
import { ref, computed, onMounted, getCurrentInstance } from 'vue';
import CollectionImages from '@/components/ui/CollectionImages.vue';
import { useNotification } from '@/components/ui/notification';
import { ElButton, ElDrawer } from 'element-plus';
import TempImg from '@/assets/images/no-image.png';

const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const event = app.appContext.config.globalProperties.EventBus;
const { openNotBottom } = useNotification();
const emit = defineEmits(['add']);
const props = defineProps({
  merchant_account_id: {
    type: Number,
    default: 0,
  },
});

const is_can_save = computed(() => {
  return add_ids.value.length === 0 && remove_ids.value.length === 0;
});

const is_show_drawer = ref(false);
const collections = ref([]);
const paged = ref(1);
const is_loading = ref(false);
const is_updating = ref(false);
const is_end = ref(false);
const is_loading_more = ref(false);
const add_ids = ref([]);
const remove_ids = ref([]);
const active_products = ref([]);


const open = (ids) => {
  is_show_drawer.value = true;
  active_products.value = ids;
  getCollections();
};

const close = () => {
  add_ids.value = [];
  remove_ids.value = [];
  active_products.value = [];
  is_show_drawer.value = false;
};

const select = (collection) => {
  if(collection.is_disabled) {
    return;
  };
  collection.is_selected = !collection.is_selected;
  const idsArray = collection.active_type === 'add' ? add_ids : remove_ids;
  const collectionId = collection.id;

  if (idsArray.value.includes(collectionId)) {
    idsArray.value = idsArray.value.filter(id => id !== collectionId);
  } else {
    idsArray.value.push(collectionId);
  }
};

const save = () => {
  const ajaxs = [];
  is_updating.value = true;

  if (add_ids.value.length > 0) {
    ajaxs.push(ajax.post('/storefront-curation/add-curation-collection-item', {
      'product_ids': active_products.value,
      'curation_collection_ids': add_ids.value,
    }));
  }

  if (remove_ids.value.length > 0) {
    ajaxs.push(ajax.post('/storefront-curation/remove-curation-collection-item', {
      'product_ids': active_products.value,
      'curation_collection_ids': remove_ids.value,
    },
    ));
  }

  let text = '';

  if (add_ids.value.length > 0 && remove_ids.value.length > 0) {
    text = 'Added and removed from collections';
  } else if (add_ids.value.length > 0) {
    text = 'Added product(s) to collections';
  } else if (remove_ids.value.length > 0) {
    text = 'Removed product(s) from collections';
  }

  Promise.all(ajaxs).then(() => {
    is_updating.value = false;
    openNotBottom(text, 'success');
    event.emit('refresh-storefront-collection-table');
    event.emit('refresh-storefront-product-table');
    close();
  });
};

const getCollections = (is_next = false) => {
  if (is_next) {
    paged.value += 1;
    is_loading_more.value = true;
  } else {
    paged.value = 1;
    collections.value = [];
    is_end.value = false;
    is_loading.value = true;
  }
  
  ajax.get('storefront-curation/get-curation-collection-list', { //get-unreleased-curation-collection
    params: {
      page: paged.value,
    },
  }).then((res) => {
    const items = res.data.data.data;
    console.log("items", items);
    items.forEach((item) => {
      if (active_products.value.length === 1) {
        item.products?.forEach((product) => {
          if (product.id === active_products.value[0]) {
            item.is_selected = true;
          }
        });
      } else {
        item.is_selected = false;
      }

      item.active_type = item.is_selected ? 'remove' : 'add';
      collections.value.push(item);
    });

    is_end.value = res.data.data.last_page === paged.value;
  }).finally(() => {
    is_loading.value = false;
    is_loading_more.value = false;
  });
};

const addCollection = (collection) => {
  collection.is_selected = false;
  collection.active_type = 'add';
  collections.value.unshift(collection);
};

onMounted(() => {
  event.off('add-products-to-collections');
  event.on('add-products-to-collections', open);
});

defineExpose({
  addCollection,
  // open,
  // close,
});
</script>

<style lang="scss">
.add-product-to-collections-drawer {
  border-radius: var(--radius-large);
  width: 440px !important;
  margin-left: -220px !important;
  left: 50% !important;
  right: auto !important;
  max-height: unset;
  height: auto !important;
  margin-bottom: 20px;

  @media screen and (max-width: $mobile_size) {
    width: 100% !important;
    margin-left: 0 !important;
    left: 0 !important;
    right: auto !important;
    margin-bottom: 0;
    border-radius: var(--radius-large) var(--radius-large) 0 0;
  }

  .head {
    display: flex;
    align-items: center;
    padding: 0 16px;
    height: 48px;
    background-color: var(--Bg-light);

    i {
      cursor: pointer;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 4px;
      color: var(--Text-primary);

      svg {
        width: 20px;
        height: 20px;
      }
    }

    h2 {
      font: var(--medium-20);
      color: var(--Text-primary);
      flex: 1;
    }

  }

  .list-wrap {
    padding: 8px 16px;
    max-height: 50vh;
    min-height: 222px;
    overflow-y: auto;
    background-color: var(--Bg-01);

    .empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      color: #7C85CE;
      padding: 32px 0;
      position: relative;

      i {
        height: 52px;
        width: 52px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 16px;

        svg {
          width: 52px;
          height: 52px;
        }
      }

      button {
        padding-left: 16px;
        padding-right: 16px;
        margin-top: 16px;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
        }

        svg {
          margin-right: 6px;
          height: 10px;
          width: 10px;
        }
      }
    }

    .collection-list {
      li {
        margin: 8px 0;
        padding: 4px;
        border-radius: var(--radius);
        background-color: var(--Bg-light);
        display: flex;
        align-items: center;
        cursor: pointer;
        overflow: hidden;

        .collection-grid {
          height: 68px;
          width: 68px;
          border-radius: var(--radius);
          overflow: hidden;
          position: relative;
        }

        &>i {
          height: 20px;
          width: 20px;
          margin-right: 8px;

          svg {
            width: 20px;
            height: 20px;
            fill: var(--Black-60);

            &.svg-icon__checked-circle {
              fill: var(--dark-blue);
            }
          }
        }

        .info {
          flex: 1;
          padding: 0 8px;

          h3 {
            font: var(--medium-16);
            color: var(--Text-primary);
            margin-bottom: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          p {
            font-size: 12px;
            color: var(--Text-secondary);
            margin: 0;
          }

          span {
            font-size: 12px;
            color: var(--Text-secondary);
            display: flex;
            align-items: center;

            svg {
              width: 12px;
              height: 12px;
              margin-right: 4px;
            }
          }
        }
      }

      .dis-li{
        pointer-events: none;
        opacity: 0.8;
      }
    }

    .more-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px 0;
      color: var(--Text-default);
      font-size: 12px;
    }
  }

  .foot {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 16px;
    background-color: var(--Bg-light);
    gap: 12px;

    .el-button {
      &:first-child {
        padding-left: 16px;
        padding-right: 16px;
      }

      &:last-child {
        flex: 1;
        margin: 0;
      }

      svg {
        margin-right: 6px;
        height: 10px;
        width: 10px;
      }
    }
  }

  .el-drawer__header {
    display: none;
  }

  .el-drawer__body {
    padding: 0;
  }

}
</style>
